import { useQuery } from "react-query";
import { getAllAL3Data } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetAllAL3Data = () => {
  return useQuery(["getAL3Data"], () => getAllAL3Data(), {
    refetchOnWindowFocus: false,
  });
};
export default useGetAllAL3Data;
